export function attachmentViewerFileKind(
  url: string,
): 'pdf' | 'image' | 'document' | 'spreadsheet' | 'unknown' {
  const pathOnly = url.split('?')[0];
  const extension = pathOnly.split('.').pop()?.toLowerCase() || '';

  if (extension === 'pdf') return 'pdf';
  if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) return 'image';
  if (['doc', 'docx'].includes(extension)) return 'document';
  if (['xls', 'xlsx', 'csv'].includes(extension)) return 'spreadsheet';

  return 'unknown';
}
